import { render } from "./CreditiUsciti.vue?vue&type=template&id=60571033&scoped=true"
import script from "./CreditiUsciti.vue?vue&type=script&lang=js"
export * from "./CreditiUsciti.vue?vue&type=script&lang=js"

import "./CreditiUsciti.vue?vue&type=style&index=0&id=60571033&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60571033"]])

export default __exports__